import { Building2 } from 'lucide-react';
import { useCompanyContext, needsCompanySelection } from '../context/CompanyContext';
import { useLang } from '../context/LangContext';
import { t } from '../i18n/dictionary';

/**
 * Aviso cuando hay varias empresas y ninguna seleccionada (p. ej. tras un
 * SIGNED_OUT que borró quipus_company). Sin esto las páginas quedan vacías
 * sin explicación aunque los datos estén intactos.
 */
export default function NoCompanySelectedBanner() {
  const { companiesLoaded, companiesCount, activeCompany } = useCompanyContext();
  const { lang } = useLang();

  if (!needsCompanySelection(companiesLoaded, companiesCount, !!activeCompany)) return null;

  return (
    <div
      role="status"
      style={{ background: 'var(--brand-soft)', borderBottom: '1px solid var(--brand-soft)' }}
      className="flex items-center gap-2 px-6 py-2 text-sm text-[var(--link)]"
    >
      <Building2 size={14} className="shrink-0" />
      <span>{t('company.selectPrompt', lang)}</span>
    </div>
  );
}
